import Immutable from 'immutable';
import { createReducer } from '../utils';
import * as types from '../actionTypes/reportsTabActionTypes';

const initState = Immutable.fromJS({
  reports: [],
  receipts: [],
  isReportsDataReady: null,
  isAutoMateMailingReady: null,
  isReportsDataErrorOccurred: false,
  isAutoMateMailingReadyErrorOccurred: false,
  errorMessage: null,
  automateMailing: {
    isLoading: false,
  },
});

export default createReducer(initState, {

  SERVER_ERROR: (state, action) => state.mergeDeep({
    isReportsDataErrorOccurred: true,
    isReportsDataReady: true,
    errorMessage: action.error,
    automateMailing: {
      isLoading: false,
    },
  }),


  [types.RECEIVE_REPORTS]: (state, action) => {
    const { resBody } = action;

    return state.merge({
      reports: resBody.data,
      csvDownloadLink: resBody.csv_download_link,
      csvDownloadUrl: resBody.csv_download_files_url,
      receipts: resBody.receipts,
      isReportsDataReady: true,
    });
  },

  [types.REQUEST_REPORTS]: state => state.merge({
    isReportsDataErrorOccurred: false,
    isReportsDataReady: false,
    isAutoMateMailingReadyErrorOccurred: false,
    isAutoMateMailingReady: false,
    isReportDataReceived: false,
  }),

  [types.REQUEST_AUTOMATE_MAILING_REPORTS]: state => state.mergeDeep({
    isAutoMateMailingReady: false,
    automateMailing: {
      isLoading: true,
    },
  }),

  [types.RECEIVE_AUTOMATE_MAILING_REPORTS]: (state, action) => {
    const { error } = action.resBody;

    return state.mergeDeep({
      isAutoMateMailingReady: true,
      isAutoMateMailingReadyErrorOccurred: !!error,
      errorMessage: error,
      automateMailing: {
        isLoading: false,
      },
    });
  },
});



// WEBPACK FOOTER //
// ./src/redux/reducers/reportsTabReducer.js